// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.contain-router {\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/navigation/StaticNavigation/StaticNavigation.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB","sourcesContent":["\n.contain-router {\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
